import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
export class TextLink extends Component {
  render() {
    var _this$props = this.props,
        children = _this$props.children,
        href = _this$props.href,
        tagName = _this$props.tagName,
        props = _objectWithoutProperties(_this$props, ["children", "href", "tagName"]);

    var Tag = tagName;
    var moreProps = tagName === 'a' ? {
      href
    } : {};
    return /*#__PURE__*/React.createElement(Tag, _extends({}, props, moreProps), children);
  }

}
/** @component */

_defineProperty(TextLink, "propTypes", {
  /**
   * Anything wrapped by TextLink
   */
  children: PropTypes.node.isRequired,
  href: PropTypes.string,

  /**
   * Render styles with a specific HTML element tag
   */
  tagName: PropTypes.oneOf(['a', 'button']).isRequired
});

_defineProperty(TextLink, "defaultProps", {
  href: '#',
  tagName: 'a'
});

export default styled(TextLink).withConfig({
  displayName: "TextLink",
  componentId: "sc-1di4qj0-0"
})(["\n  ", ";\n"], props => props.theme.link ? props.theme.link.defaultStyle : null);